import { render, staticRenderFns } from "./onlineDetail.vue?vue&type=template&id=c0fd17f0&scoped=true&"
import script from "./onlineDetail.vue?vue&type=script&lang=js&"
export * from "./onlineDetail.vue?vue&type=script&lang=js&"
import style0 from "./onlineDetail.vue?vue&type=style&index=0&id=c0fd17f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0fd17f0",
  null
  
)

export default component.exports